import { Button } from '@prophecy/ui-v3/Button';
import { Text } from '@prophecy/ui-v3/Typography';

export function RunLink({
  runId,
  hasRun,
  onSelectRun
}: {
  runId: string;
  hasRun: (runId: string) => boolean;
  onSelectRun: (runId: string) => void;
}) {
  // ids recorded before trigger tracking may be legacy numbers that match no row
  if (!hasRun(runId)) return <Text level='sm'>{runId}</Text>;
  return (
    <Button
      variant='link'
      size='xs'
      onClick={() => onSelectRun(runId)}
      data-test-id={`sql-pipeline-run-details-run-link-${runId}`}>
      {runId}
    </Button>
  );
}
